import { render, staticRenderFns } from "./activity816.vue?vue&type=template&id=ddbfe7c8&scoped=true&"
import script from "./activity816.vue?vue&type=script&lang=js&"
export * from "./activity816.vue?vue&type=script&lang=js&"
import style0 from "./activity816.vue?vue&type=style&index=0&id=ddbfe7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbfe7c8",
  null
  
)

export default component.exports